import { logger } from '@src/utils/misc/logger';
import apptracker from '@src/utils/sensor/apptracker';
import { NEXA_DASHBOARD_LINK_CLICK } from '@src/utils/sensor/track';
import { HandlerOptions } from './types';

/**
 * Handles generate_static_report tool - opens report panel with specific version
 */
export const handleReportView = (options: HandlerOptions): void => {
  try {
    const { rawConfig, setIsReportPanelOpen, setActiveReportVersion } = options;

    // Extract version from rawConfig (backend stores it at top level, not in args)
    const version = rawConfig?.version;

    if (!setIsReportPanelOpen || !setActiveReportVersion) {
      logger.error('Missing required setters for report panel');
      return;
    }

    // Open report panel
    setIsReportPanelOpen(true);

    // If version is provided, set it to load that specific version
    if (version) {
      setActiveReportVersion(version);
      logger.log('Opened report panel with version:', version);
    } else {
      logger.log('Opened report panel');
    }

    apptracker(NEXA_DASHBOARD_LINK_CLICK, { type: 'report_view', version });
  } catch (error) {
    logger.error('Error handling report view:', error);
  }
};
